export default "__VITE_ASSET__B1e92Wc0__"